import type { QuickHit } from "@averagejoesff/shared";
import type { ManagerLookup } from "./managers";
import { managerName } from "./managers";

interface QuickHitsProps {
  hits: QuickHit[];
  managers: ManagerLookup;
}

/** League-wide one-liners, shown above the week's matchup cards. */
export function QuickHits({ hits, managers }: QuickHitsProps) {
  if (hits.length === 0) return null;
  return (
    <section aria-labelledby="quick-hits-heading">
      <h3 id="quick-hits-heading" className="feature__subhead quick-hits__title">
        Quick Hits
      </h3>
      <ul className="quick-hits">
        {hits.map((hit, i) => (
          <li key={i} className="quick-hits__item">
            <span className="quick-hits__emoji" aria-hidden="true">
              {hit.emoji}
            </span>
            <span className="quick-hits__label">{hit.label}</span>
            <span className="quick-hits__who">
              {hit.managerIds.map((id) => managerName(managers, id)).join(" & ")}
            </span>
            <span className="quick-hits__detail">{hit.detail}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
